// extracted by mini-css-extract-plugin
export default {"switch":"toggle-switch_switch__YlKxP","slider":"toggle-switch_slider__WWYTd","thumb":"toggle-switch_thumb__XQpff"};